export default __webpack_public_path__ + "static/media/IMG_20141225_215615.f383de3c.jpg";